<template>
  <b-sidebar
    id="sidebar-update-student"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Update student') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>
      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="studentUpdate">

          <b-form-group
            :label="$t('Research Advisor')"
            label-for="advisor"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Research Advisor')"
            >
              <v-select
                v-model="advisorStudent.advisor_id"
                :options="advisorList"
                :reduce="(option) => option.id"
                :get-option-label="(option) => option.full_name"
                @search="fetchAdvisor"
                @input="inputAdvisor"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </validation-observer>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ $t('Update') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BSidebar,
    BForm,
    BFormGroup,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      required,
      advisors: [],
      selectedAdvisor: null,
    }
  },
  computed: {
    advisorStudent() {
      return this.$store.state[this.MODULE_NAME].advisorStudent
    },
    advisorList() {
      if (this.selectedAdvisor && !this.advisors.find(x => x.id === this.selectedAdvisor.id)) {
        return [this.selectedAdvisor, ...this.advisors]
      }
      return this.advisors
    },
  },
  mounted() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.$refs.studentUpdate.reset()
      this.$store.commit(`${this.MODULE_NAME}/UPDATE_STUDENT`, {})
      hide()
    },
    submit(hide) {
      this.$refs.studentUpdate.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.advisorStudent, `${this.MODULE_NAME}/updateStudent`, () => {
            this.$emit('refetchData')
            this.clear(hide)
          })
          hide()
        }
      })
    },
    fetchAdvisor(search, loading) {
      loading(true)
      this.$store.dispatch('staticModule/researchAdvisors', { search }).then(res => {
        this.advisors = res
        loading(false)
      })
    },
    inputAdvisor(id) {
      this.selectedAdvisor = this.advisors.find(x => x.id === id)
    },
  },
  setup() {
    const MODULE_NAME = 'researchAdvisor'
    return {
      MODULE_NAME,
    }
  },
}
</script>
